import PageInitializer from './libs/page-initializer';
import FocusVisibleManager from './libs/focus-visible-manager';
import { EVENT_READY, EVENT_UPDATE_VIEW, EVENT_GLOBAL_CART_ACTIVATE } from './constants/event';
import AddCartButton from './components/parts/add-cart-button';
import ProductActions from './components/parts/product-actions';
import CartModal from './components/global/cart-modal';
import CartIcon from './components/global/cart-icon';
import FaqItem from './components/parts/faq-item';
import Header from './components/global/header';

import GlobalMenu from './components/global/global-menu';
// フォーカス表示管理の初期化
FocusVisibleManager.getInstance();

// Component instances storage
const componentInstances = new Map<HTMLElement, any>();

// Initialize components
function initializeComponents(): void {
  console.log('[Global] Initializing components...');

  // Initialize Add to Cart Buttons
  const addCartButtons = document.querySelectorAll<HTMLElement>('.js-add-cart-button');
  console.log('[Global] Found', addCartButtons.length, 'add to cart buttons');
  addCartButtons.forEach((element) => {
    if (!componentInstances.has(element)) {
      const instance = new AddCartButton(element);
      componentInstances.set(element, instance);
    }
  });

  // Initialize Product Actions
  const productActions = document.querySelectorAll<HTMLElement>('.js-product-actions');
  console.log('[Global] Found', productActions.length, 'product actions');
  productActions.forEach((element) => {
    if (!componentInstances.has(element)) {
      const instance = new ProductActions(element);
      componentInstances.set(element, instance);
    }
  });

  // Initialize Cart Modal (should be only one)
  const cartModal = document.querySelector<HTMLElement>('.js-cart-modal');
  console.log('[Global] Cart modal:', cartModal);
  if (cartModal && !componentInstances.has(cartModal)) {
    const instance = new CartModal(cartModal);
    componentInstances.set(cartModal, instance);
  }

  // Initialize Cart Modal Triggers
  const cartModalTriggers = document.querySelectorAll<HTMLElement>('.js-cart-modal-trigger');
  console.log('[Global] Found', cartModalTriggers.length, 'cart modal triggers');
  cartModalTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      console.log('[Global] Cart modal trigger clicked');
      document.dispatchEvent(new CustomEvent(EVENT_GLOBAL_CART_ACTIVATE));
    });
  });

  // Initialize Cart Icons
  const cartIcons = document.querySelectorAll<HTMLElement>('.js-cart-icon');
  console.log('[Global] Found', cartIcons.length, 'cart icons');
  cartIcons.forEach((element) => {
    if (!componentInstances.has(element)) {
      const instance = new CartIcon(element);
      componentInstances.set(element, instance);
    }
  });

  // Initialize FAQ Items
  const faqItems = document.querySelectorAll<HTMLElement>('.js-faq-content-item');
  console.log('[Global] Found', faqItems.length, 'FAQ items');
  faqItems.forEach((element) => {
    if (!componentInstances.has(element)) {
      const instance = new FaqItem(element);
      componentInstances.set(element, instance);
    }
  });

  // Initialize Headers
  const headers = document.querySelectorAll<HTMLElement>('.js-global-header');
  console.log('[Global] Found', headers.length, 'headers');
  headers.forEach((element) => {
    if (!componentInstances.has(element)) {
      const instance = new Header(element);
      componentInstances.set(element, instance);
    }
  });

  // Initialize SP Global Menu
  const globalMenus = document.querySelectorAll<HTMLElement>('.js-global-menu');
  globalMenus.forEach((element) => {
    if (!componentInstances.has(element)) {
      const instance = new GlobalMenu(element);
      componentInstances.set(element, instance);
    }
  });

  console.log('[Global] Components initialized. Total instances:', componentInstances.size);
}

// Clean up destroyed components
function cleanupComponents(): void {
  componentInstances.forEach((instance, element) => {
    if (!element.isConnected) {
      componentInstances.delete(element);
    }
  });
}

PageInitializer.getInstance()
  .ready()
  .then(() => {
    const body = document.body;
    body.classList.add('is-loaded');

    // Initialize components on ready
    initializeComponents();

    document.dispatchEvent(new Event(EVENT_READY));
  });

// Re-initialize components when view updates (for dynamic content)
document.addEventListener(EVENT_UPDATE_VIEW, () => {
  cleanupComponents();
  initializeComponents();
});
